import React, { useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import PeopleIcon from "../assets/images/hr_rgb_red.svg";
import "../assets/styles/users.scss";
import api from "../services/httpClient";
import CreateUserForms from "../components/Users/Create/CreateUserForms";
const UserCreateNew = () => {
  return (
<div className="users-container">
      <Container fluid>
        <Row className="align-items-center mb-4">
          <Col xs="auto">
            <img
              src={PeopleIcon}
              alt="People Icon"
              style={{ width: "30px", height: "30px" }}
            />
          </Col>
          <Col>
            <h3 style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
              Dodaj użytkownika
            </h3>
          </Col>
        </Row>
        <Row className="align-items-center mb-4">
        </Row>
        <Row>
          <Col>
            <CreateUserForms />
          </Col>
        </Row>
      </Container>
    </div>
  )};

export default UserCreateNew;